import React, { useState } from 'react';
import ExcelImportPopup from '../Common/ExcelImportPopup';

interface UseExcelImportPopupResult {
  showImport: () => void;
  hideImport: () => void;
  ImportPopup: React.ReactNode;
}

interface UseExcelImportPopupOptions {
  templateUrl: string;
  onUpload: (file: File) => Promise<void>;
  title?: string;
}

export function useExcelImportPopup({ templateUrl, onUpload, title }: UseExcelImportPopupOptions): UseExcelImportPopupResult {
  const [visible, setVisible] = useState(false);

  const showImport = () => setVisible(true);
  const hideImport = () => setVisible(false);

  const ImportPopup = (
    <ExcelImportPopup
      visible={visible}
      onHide={hideImport}
      templateUrl={templateUrl}
      onUpload={onUpload}
      title={title}
    />
  );

  return { showImport, hideImport, ImportPopup };
}
